import { h, Component } from 'preact';
import { connect } from 'react-redux';
import reduce from '../reducers';
import * as actions from '../actions';
import designDomain from '../domain/designDomain';
import illustrationService from '../service/illustrationService';
import Spinner from "./Spinner";
import designService from "../service/designService";
import $ from "jquery";
import constants from "../constants";
import linkRef from "linkref";
import { createPortal } from "preact/compat";
import util from '../util';
import { LoadingOutlined } from '@ant-design/icons';


export default @connect(reduce, actions)
class ConfigureIllustrationModal extends Component {

  constructor() {
    super();

    this.state = {
      isLoadingDetails: false,
      picker: '',
      config: '',

      id: '',
      privacy: '',
      content: '',
      configuration: '',
      tags: [],
      folders: [],
      popular: 'false',

      tagSuggestions: [],
      newTagName: '',
      folderSuggestions: [],
      newFolderName: '',
      customColor: '',
      widgetColor: '#000000',

      isSaveLoading: false,
    };

    this.remove = () => {
      if (!this.props.isDesigner) return;
      const multiLength = this.props.multipleConfigureIllustrations.length;
      window.ConfirmationModal.show({
        title: 'Are you sure?',
        body: `${multiLength > 0 ? multiLength + 'illustrations' : 'This illustration'} will be removed from the gallery.`,
        acceptLabel: 'OK',
        declineLabel: 'Cancel',
        onAccept: () => {
          if (multiLength > 0) {
            this.setState({isSaveLoading: true});
            this.removeMultiple(this.props.multipleConfigureIllustrations);
          } else {
            designService.removeIllustration(this.state.id).then(response => {
              this.props.onModalClose()
            })
          }
        },
        onDecline: () => {
          window.ConfirmationModal.hide()
        }
      })
    };

    this.removeMultiple = (toRemoveList) => {
      if (toRemoveList.length === 0) {
        this.setState({isSaveLoading: false});
        this.props.onModalClose();
      } else {
        const thisIllustration = toRemoveList[0];
        designService.removeIllustration(thisIllustration.id).then(resp => {
          toRemoveList.shift();
          console.log(toRemoveList.length + ' designs remaining');
          this.removeMultiple(toRemoveList);
        }).catch((err) => {
          window.InfoModal.show({
            title: 'Whoops!',
            body: 'We failed to save your work. Please try again later!',
            acceptLabel: 'Got it',
          })
        })
      }
    }

    this.save = () => {
      if (this.props.multipleConfigureIllustrations.length > 0) {
        this.setState({isSaveLoading: true});
        this.saveMultiple(this.props.multipleConfigureIllustrations);
      } else {
        illustrationService.updateIllustration({
          id: this.state.id,
          privacy: this.state.privacy,
          configuration: this.state.configuration,
          tags: this.state.tags,
          folders: this.state.folders,
          popular: this.state.popular,
        }).then(response => {
          this.props.onModalClose()
        }).catch((err) => {
          window.InfoModal.show({
            title: 'Whoops!',
            body: 'We failed to save your work. Please try again later!',
            acceptLabel: 'Got it',
          })
        })
      }
    };

    this.saveMultiple = (toSaveList) => {
      if (toSaveList.length === 0) {
        this.setState({isSaveLoading: false});

        setTimeout(() => {
          this.props.onModalClose();
        }, 100);
      } else {
        const thisIllustration = toSaveList[0];
        illustrationService.updateIllustration({
          id: thisIllustration.id,
          popular: this.state.popular,
        }).then(resp => {
          toSaveList.shift();
          console.log(toSaveList.length + ' designs remaining');
          this.saveMultiple(toSaveList);
        }).catch((err) => {
          window.InfoModal.show({
            title: 'Whoops!',
            body: 'We failed to save your work. Please try again later!',
            acceptLabel: 'Got it',
          })
        })
      }
    }

    this.onChangePrivacy = (ev) => {
      this.setState({ privacy: ev.target.value });
    };

    this.onChangePopular = (ev) => {
      this.setState({ popular: ev.target.value });
    };

    this.removeTag = (tag) => {
      this.setState({ tags: this.state.tags.filter(t => t.id !== tag.id) });
    };

    this.addTag = (tag) => {
      const found = this.state.tags.find(t => t.id === tag.id);
      if (found) return;

      this.setState({
        tags: [tag, ...this.state.tags],
        tagSuggestions: [],
        newTagName: ''
      });
    };

    this.createTag = (tag) => {
      const name = tag || this.state.newTagName;
      const dto = [];
      if (name.indexOf(',') > -1) {
        name.split(',').forEach(it => {
          dto.push({ name: it.trim() })
        })
      } else {
        dto.push({ name });
      }
      illustrationService.createTag(dto).then(resp => {
        resp.data.forEach(it => {
          setTimeout(() => {
            this.addTag(new designDomain.DesignIllustrationTag(it));
          }, 50);
        });
      })
    }

    this.updateNewTagName = (ev) => {
      this.setState({ newTagName: ev.target.value });
    };

    this.onNewTagKeyUp = (ev) => {
      if (ev.keyCode === 13 || ev.keyCode === 188) {
        const value = ev.keyCode === 188 ? ev.target.value.slice(0, -1) : ev.target.value
        this.createTag(value);
        this.resetNewTag();
      }
    };

    this.removeFolder = (folder) => {
      this.setState({ folders: this.state.folders.filter(f => f.id !== folder.id) });
    };

    this.addFolder = (folder) => {
      const found = this.state.folders.find(c => c.id === folder.id);
      if (found) return;

      this.setState({
        folders: [folder, ...this.state.folders],
        folderSuggestions: [],
        newFolderName: ''
      })
    };

    this.createFolder = (folder) => {
      illustrationService.createFolder({
        name: folder || this.state.newFolderName
      }).then((response) => {
        this.addFolder(new designDomain.DesignIllustrationFolder(response.data))
      })
    };

    this.updateNewFolderName = (ev) => {
      this.setState({ newFolderName: ev.target.value })
    };

    this.onNewFolderKeyUp = (ev) => {
      this.fetchFolderSuggestions(ev.target.value);
      if (ev.keyCode === 13 || ev.keyCode === 188) {
        const value = ev.keyCode === 188 ? ev.target.value.slice(0, -1) : ev.target.value;
        this.createFolder(value);
        this.resetNewFolder();
      }
    };

    this.fetchFolderSuggestions = (name) => {
      if (name.length > 1) {
        // illustrationService.findFolders(name).then(response => {
        //     // this.setState({ newFolderName: name })
        //     const folders = response.data.map(folder => new designDomain.Folder(folder))
        //     this.setState({
        //         folderSuggestions: folders
        //     })
        // })
      }
    };

    this.resetNewTag = () => {
      this.setState({
        newTagName: '',
        tagSuggestions: []
      });
    };

    this.resetNewFolder = () => {
      this.setState({
        newFolderName: '',
        folderSuggestions: []
      });
    };

    this.updateColor = (config, color) => {
      const configuration = JSON.parse(this.state.configuration);
      configuration.find(it => it.id === config.id).color = color;

      this.setState({ configuration: JSON.stringify(configuration) });

      const $element = $('.svg-image .svg-content');
      const $editable = $element.find('[data-custom-color]');

      configuration.forEach(config => {
        $editable.each(function () {
          const $this = $(this);
          const cfgs = JSON.parse($this.attr('data-config'));
          cfgs.forEach(cfg => {
            if (cfg.id === config.id) {
              $this.css(config.rule, config.color);
            }
          });
        })
      });
    };

    this.download = () => {
      jQuery.fileDownload(constants.appPrefix + '/api/illustration/download/' + this.state.id + '.svg')
        .done(() => { })
    };

    this.saveCustomColor = () => {
      if (!this.state.customColor || !this.state.config) return;
      this.updateColor(this.state.config, '#' + this.state.customColor);
    };

    this.manualChangeCustomColor = (ev) => {
      const color = ev.target.value;
      this.setState({ 'customColor': color });
    }

  }

  componentDidUpdate() {
    this.initializePicker();
  }

  init(illustration) {
    this.setState({
      id: illustration.id,
      content: illustration.content,
      configuration: illustration.configuration,
      privacy: illustration.privacy,
      tags: illustration.tags || [],
      folders: illustration.folders || [],
      popular: illustration.popular || 'false',
      picker: '',
      config: '',
    })
  }

  initializePicker() {
    if (!this.state.picker && this.refs && this.refs['new-illustration-color']) {
      const picker = ColorPicker(this.refs['new-illustration-color'], (hex, hsv, rgb) => {
        this.setState({ 'customColor': hex.slice(1) });
        this.saveCustomColor()
      });

      this.setState({ picker: picker });
      picker.setHex(this.state.widgetColor)
    }
  }

  openEyedropper() {
    if (!window.EyeDropper) {
      console.log('Your browser does not support the EyeDropper API');
      return;
    }

    const eyeDropper = new EyeDropper();

    eyeDropper.open().then(result => {
      console.log("result eyedroper ", result);
      this.setState({ 'customColor': result.sRGBHex });
      this.setState({ 'widgetColor': result.sRGBHex });
      this.updateColor(this.state.config, result.sRGBHex);
      this.state.picker.setHex(result.sRGBHex);
    }).catch(e => {
      console.log("eyedropper error ", e);
    });
  }

  render({ open, illustrationToConfigure, multipleConfigureIllustrations, onModalClose, into = 'body', children, isAdmin },
    {
      id, tags, privacy, popular, newTagName, tagSuggestions, folders, newFolderName, folderSuggestions, isLoadingDetails,
      content, configuration, customColor
    }) {

    let isMultipleMode = false;
    if (multipleConfigureIllustrations.length > 0) {
      isMultipleMode = true;
    } else if (illustrationToConfigure && illustrationToConfigure.id !== id) {
      this.init(this.props.illustrationToConfigure);
    }

    tags.sort((a, b) => a.name.localeCompare(b.name))

    const tagElements = tags.map(tag => {
      return (
        <div className="tag">
          {tag.name}
          <a className="remove" onClick={() => this.removeTag(tag)}>x</a>
        </div>
      )
    });

    const suggestionElements = tagSuggestions.map(suggestion => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addTag(suggestion)}>{suggestion.name}</a>
        </li>
      )
    });

    let suggestions = null;
    if (tagSuggestions.length > 0) {
      suggestions = <div className="suggestions">{suggestionElements}</div>
    } else if (newTagName.length > 0) {
      suggestions = <div className="new-tag"><a onClick={() => this.createTag()}>+ Create Tag</a></div>
    }

    const folderElements = folders.map(folder => {
      return (
        <div className="tag">
          {folder.name}
          <a className="remove" onClick={() => this.removeFolder(folder)}>x</a>
        </div>
      )
    });

    const folderSuggestionElements = folderSuggestions.map(folder => {
      return (
        <li className="suggestion">
          <a onClick={() => this.addFolder(folder)}>{folder.name}</a>
        </li>
      )
    });

    let folSuggestions = null;
    if (folderSuggestions.length > 0) {
      folSuggestions = <div className="suggestions">{folderSuggestionElements}</div>
    }

    let colors = '';
    let illustration = '';

    if (configuration) {
      const configs = JSON.parse(configuration);
      const $content = $(content);
      const $editable = $content.find('[data-custom-color]');

      configs.forEach(config => {
        $editable.each(function () {
          const $this = $(this);
          const cfgs = JSON.parse($this.attr('data-config'));
          cfgs.forEach(cfg => {
            if (cfg.id === config.id) {
              $this.css(config.rule, config.color);
            }
          });
        });
      });

      const contentHtml = $("<div />").append($content.clone()).html();

      illustration = <div className="svg-content" style="width: 90%; margin: 0px auto 10px auto;" dangerouslySetInnerHTML={{ __html: contentHtml }}></div>;

      colors = configs.map((config) =>
        <li style="min-width: 20px; width: auto; text-align: center; margin-right: 5px; list-style: none; display: inline-block;">
          <div className="dropdown" style="position: relative;">
            <a className="dropdown-toggle car icn">
              <span className="color-box" style={'background:' + config.color}></span>
            </a>
            <div className="dropdown-menu large" data-close="no">
              <div className="angle left"></div>
              <div className="scroll">

                <div className="title">
                  <h6>Palette</h6>
                </div>

                <div>
                  <ul className="colors">
                    <li className="dropdown">
                      <div className="add-new dropdown-toggle icn"
                        data-menu={'#new-illustration-color'}
                        data-reposition="true"
                        data-is-nested="true"
                        onClick={() => this.setState({ config: config })}>
                        <span className="plus" style="margin-left: 8px;">+</span>
                      </div>
                    </li>
                    <li onClick={() => this.updateColor(config, '#ff5c5c')} style="background: #ff5c5c" />
                    <li onClick={() => this.updateColor(config, '#ffbd4a')} style="background: #ffbd4a" />
                    <li onClick={() => this.updateColor(config, '#fff952')} style="background: #fff952" />
                    <li onClick={() => this.updateColor(config, '#99e265')} style="background: #99e265" />
                    <li onClick={() => this.updateColor(config, '#35b729')} style="background: #35b729" />
                    <li onClick={() => this.updateColor(config, '#44d9e6')} style="background: #44d9e6" />
                    <li onClick={() => this.updateColor(config, '#2eb2ff')} style="background: #2eb2ff" />
                    <li onClick={() => this.updateColor(config, '#5271ff')} style="background: #5271ff" />
                    <li onClick={() => this.updateColor(config, '#b760e6')} style="background: #b760e6" />
                    <li onClick={() => this.updateColor(config, '#ff63b1')} style="background: #ff63b1" />
                    <li onClick={() => this.updateColor(config, '#000000')} style="background: #000000" />
                    <li onClick={() => this.updateColor(config, '#444444')} style="background: #444444" />
                    <li onClick={() => this.updateColor(config, '#AAAAAA')} style="background: #AAAAAA" />
                    <li onClick={() => this.updateColor(config, '#FFFFFF')} style="background: #FFFFFF; border: 1px solid rgb(230, 230, 230);" />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </li>
      )
    }


    const loadingSpinner = isLoadingDetails ? <Spinner /> : null;

    return open ? createPortal(<div>
      <div className="modal-back" onClick={onModalClose}></div>
      <div className="modal config-modal" style="transition: left 0.4s cubic-bezier(0.87, 0.04, 0.21, 1.12) 0s;">
        {loadingSpinner}

        <div className="content">
          {!isMultipleMode &&
          <div className="svg-image" style="width:40%; display: inline-block; padding: 20px 20px 0px 0px; vertical-align: top;">
            {illustration}
          </div>}
          <div className="svg-fields" style={`${isMultipleMode ? 'width:100%;' : 'width:60%;'} display: inline-block; vertical-align: top;`}>
            <header>
              {!isMultipleMode && <h2 style="padding-left: 0;">Illustration Settings</h2>}
              {isMultipleMode && <h2 style="padding-left: 0;">Configure {multipleConfigureIllustrations.length} Illustrations</h2>}
            </header>

            {!isMultipleMode && <div className="form-block">
              <label>Privacy</label>
              <select value={privacy} onChange={this.onChangePrivacy}>
                <option value="private">Private</option>
                <option value="public">Public</option>
              </select>
            </div>}

            {!isMultipleMode &&
            <div className="form-block">
              <label>Colors</label>
              <ul style="padding: 0; margin: 0px;">
                {colors}

                <div id="new-illustration-color" className="custom-color-picker-widget dropdown-menu large" data-close="no" onMouseLeave={this.saveCustomColor}>
                  <div className="color-picker cp-default clearfix" ref={linkRef(this, 'new-illustration-color')}></div>
                  <div className="hex-input clearfix">
                    <label>Color code #</label>
                    <input type="text" value={customColor} onKeyUp={this.manualChangeCustomColor} maxLength="6" />
                    <a onClick={() => this.openEyedropper()} className={util.isSafari() || util.isFirefox() ? "hidden" : "eyedropper-container"}>
                      <svg><use xlinkHref={constants.appPrefix + "/svg/icons.svg#eyedropper-icon"} /></svg>
                    </a>
                  </div>
                </div>
              </ul>
            </div>}

            {!isMultipleMode && <div className="form-block">
              <label>Tags</label>
              <div className="tags">{tagElements}</div>
              <input type="text"
                placeholder="Tag name..."
                value={newTagName}
                onChange={this.updateNewTagName}
                onKeyUp={this.onNewTagKeyUp} />
              {suggestions}
            </div>}

            {!isMultipleMode && <div className="form-block">
              <label>Folders</label>
              <div className="tags">{folderElements}</div>
              <input type="text"
                placeholder="Folder name..."
                onKeyUp={this.onNewFolderKeyUp} />
              {folSuggestions}
            </div>}

            <div className="form-block">
              <label>Popular</label>
              <select value={popular} onChange={this.onChangePopular}>
                <option value="true">yes</option>
                <option value="false">no</option>
              </select>
            </div>

            <footer>
              <a className="btn decline" onClick={() => this.remove()}>
                {!this.state.isSaveLoading && <span>Remove</span>}
                {this.state.isSaveLoading && <LoadingOutlined color='#e42436'/>}
              </a>
              <a className="btn primary pull-right accept" onClick={() => this.save()}>
                {!this.state.isSaveLoading && <span>Save</span>}
                {this.state.isSaveLoading && <LoadingOutlined color='#fff'/>}
              </a>
              {!isMultipleMode && <a className="btn primary pull-right accept" onClick={() => this.download()}>Download</a>}
            </footer>
          </div>
        </div>
      </div>
    </div>, document.getElementById('modals')) : null;
  }
}
